import { DatePivotParams } from "../../entities/date_pivot_params";
import dayjs from "../../utils/dayjs";

export const defaultConfig: DatePivotParams = {
  // Must stay the real column name: the chunked matrix renderer passes this straight
  // through as the signed forecast-cell recipe's period.field, which only accepts
  // order_delivery_month. A caption here silently drops the explain affordance.
  dateHierarchy: "order_delivery_month",
  measure: "forecast",
  segments: [],
  minDate: dayjs.utc().startOf("year").toDate(),
  maxDate: dayjs.utc().add(1, "year").startOf("year").toDate(),
  filters: [],
  postFilters: [],
};
